import {Component} from '@angular/core';
import {ProductType} from "../../model/product";
import {ProductService} from "../../services/product.service";
import {RegionsService} from "../../services/regions.service";
import {products} from "../../var/constants";

@Component({
  selector: 'app-products',
  templateUrl: './products.component.html',
  styleUrls: ['./products.component.scss']
})
export class ProductsComponent {

  products: ProductType[];
  selectedProduct: string;
  selectedStates: any;

  constructor(
    private productService: ProductService,
    regionsService: RegionsService
  ) {
    this.selectedProduct = productService.getSelectedProductId();
    this.products = products;
    // this.products.find(product => product.id === this.selectedProduct).selected = true;
    this.selectedStates = regionsService.getSelectedStates();
  }

  selectProduct(event: any) {
    this.selectedProduct = event.target.selectedOptions[0].value;
    this.productService.setSelectedProductId(this.selectedProduct);
  }

  isProductDisabled(product: ProductType) {
    // if (product.disabled) {
    //   return true;
    // }
    // else {
    //   if (product.id === 'LB') {
    //     return false;
    //   } else {
    //     const entries = Object.entries(this.selectedStates);
    //     return entries.length !== 0 && entries.find(entry => entry[0] !== 'Nordrhein-Westfalen' && entry[1] === true);
    //   }
    // }
    return product.disabled;
  }
}
